import { render, staticRenderFns } from "./mailchimp.vue?vue&type=template&id=0e88afa3&"
import script from "./mailchimp.vue?vue&type=script&lang=js&"
export * from "./mailchimp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports